{
  "nav_dashboard": "แดชบอร์ด",
  "nav_orders": "ออเดอร์",
  "nav_orders_export": "ส่งออกออเดอร์",
  "nav_inventory": "คลังสินค้า",
  "nav_split": "แยกออเดอร์",
  "nav_returns": "คืนสินค้า",
  "nav_sino": "Sino",
  "nav_inbound": "รายงานรับสินค้า",
  "nav_notifications": "การแจ้งเตือน",
  "nav_campaigns": "แคมเปญ",
  "nav_promotions": "โปรโมชั่น",
  "nav_users": "ผู้ใช้งาน",
  "nav_audit": "บันทึกการตรวจสอบ",
  "grp_operations": "การดำเนินงาน",
  "grp_fulfillment": "การจัดส่ง",
  "grp_integrations": "การเชื่อมต่อ",
  "grp_reports": "รายงาน",
  "grp_promotion": "โปรโมชั่น",
  "grp_admin": "ผู้ดูแลระบบ",
  "tag_soon": "เร็วๆ นี้",
  "crumb_operations": "การดำเนินงาน",
  "crumb_fulfillment": "การจัดส่ง",
  "crumb_integrations": "การเชื่อมต่อ",
  "title_orders": "ออเดอร์",
  "title_order_detail": "รายละเอียดออเดอร์",
  "title_split": "แยกออเดอร์",
  "title_returns": "คืนสินค้า",
  "search_orders": "วางรหัสออเดอร์หรือค้นหาชื่อ…",
  "search_returns": "ค้นหารหัสออเดอร์ รหัสคืนสินค้า…",
  "f_all_mkp_status": "ทุกสถานะมาร์เก็ตเพลส",
  "f_all_mkp": "ทุกมาร์เก็ตเพลส",
  "f_all_status": "ทุกสถานะ",
  "f_all_seller": "ทุกผู้ขาย",
  "f_cod": "เก็บเงินปลายทาง",
  "f_prepaid": "ชำระล่วงหน้า",
  "f_date_from": "จากวันที่",
  "f_date_to": "ถึงวันที่",
  "f_date_today": "วันนี้",
  "f_date_7d": "7 วันล่าสุด",
  "f_date_month": "เดือนนี้",
  "btn_refresh": "รีเฟรช",
  "btn_export": "ส่งออก",
  "btn_clear_filters": "ล้างตัวกรอง",
  "btn_filters": "ตัวกรอง",
  "chip_stage": "ขั้นตอน: {{v}}",
  "chip_label": "เลขพัสดุ: {{v}}",
  "awb_missing": "ยังไม่มี",
  "awb_present": "มีแล้ว",
  "chip_sof": "ขนส่งเอง: {{v}}",
  "sof_only": "เฉพาะ",
  "sof_excluded": "ไม่รวม",
  "chip_courier": "ขนส่ง: {{v}}",
  "chip_ship_by": "ต้องส่งภายใน: {{v}}",
  "ship_by_overdue": "เลยกำหนด",
  "ship_by_today": "วันนี้",
  "ship_by_next_24h": "ใน 24 ชม.",
  "chip_gift_only": "ออเดอร์มีของแถม",
  "chip_gift_none": "ไม่มีของแถม",
  "btn_new_order": "ออเดอร์ใหม่",
  "kpi_total": "ออเดอร์",
  "kpi_received": "รับเข้า",
  "kpi_in_fulfillment": "กำลังจัดส่ง",
  "kpi_exceptions": "ข้อยกเว้น",
  "kpi_splits": "ออเดอร์หลักที่แยก",
  "kpi_labels": "จำนวนเลเบลรวม",
  "th_order_date": "วันที่สั่งซื้อ",
  "th_order": "ออเดอร์",
  "th_marketplace": "มาร์เก็ตเพลส",
  "th_channel": "ช่องทาง",
  "th_marketplace_status": "สถานะการตลาด",
  "th_created": "สร้างเมื่อ",
  "th_customer": "ลูกค้า",
  "ship_in": "อีก {{v}}",
  "ship_overdue": "เลยมา {{v}}",
  "h_short": "{{n}} ชม.",
  "d_short": "{{n}} วัน",
  "th_items": "รายการ",
  "th_total": "ยอดรวม",
  "th_currency": "สกุลเงิน",
  "th_status": "สถานะ",
  "th_payment": "การชำระเงิน",
  "th_source": "แหล่งที่มา",
  "th_actions": "",
  "awaiting_settlement": "รอการกระทบยอด",
  "awaiting_settlement_note": "จะอัปเดตหลังจากได้รับข้อมูลการกระทบยอด",
  "bundle_qty_breakdown": "{{multiplicity}} ต่อแพ็ค × {{qty}} ที่สั่งซื้อ = ยอดรวมนี้",
  "unconfirmed_price_tooltip": "ยังไม่ยืนยัน — รอการกระทบยอด",
  "customer_not_provided": "ไม่มีข้อมูลจากมาร์เก็ตเพลส",
  "customer_not_provided_note": "API ออเดอร์ของมาร์เก็ตเพลสไม่ได้ส่งข้อมูลลูกค้ามา — นี่คือข้อจำกัดของระบบ ไม่ใช่ข้อบกพร่อง",
  "st_received": "รับเข้า",
  "st_reserved": "จองแล้ว",
  "st_picked": "ยืนยันหยิบ",
  "st_packed": "แพ็คแล้ว",
  "st_shipped": "จัดส่งแล้ว",
  "st_delivered": "ส่งถึงแล้ว",
  "st_cancelled": "ยกเลิก",
  "st_returned": "คืนสินค้า",
  "st_superseded": "ถูกแทนที่",
  "drawer_stage_picked": "หยิบแล้ว",
  "drawer_title": "ตัวกรอง",
  "drawer_subtitle": "ตัวกรองอยู่ใน URL — แชร์ลิงก์ได้",
  "drawer_group_fulfilment": "การจัดส่ง",
  "drawer_group_order": "คำสั่งซื้อ",
  "drawer_stage": "ขั้นตอน",
  "drawer_label": "เลขพัสดุ",
  "awb_missing_title": "ยังไม่มี",
  "awb_present_title": "มีแล้ว",
  "drawer_sof": "ขนส่งของผู้ขาย",
  "sof_excluded_title": "ไม่รวม",
  "sof_only_title": "เฉพาะ",
  "drawer_courier": "ขนส่ง",
  "drawer_ship_by": "ต้องส่งภายใน",
  "ship_by_overdue_title": "เลยกำหนด",
  "ship_by_today_title": "วันนี้",
  "ship_by_next_24h_title": "ใน 24 ชม.",
  "drawer_gift": "ของแถม GWP",
  "drawer_payment_channel": "ช่องทางชำระเงิน",
  "drawer_seller": "ผู้ขาย",
  "any": "ทั้งหมด",
  "btn_reset": "รีเซ็ต",
  "btn_apply": "ใช้ตัวกรอง",
  "btn_apply_n": "ใช้ตัวกรอง {{n}}",
  "act_view": "ดูรายละเอียด",
  "back_to_orders": "กลับไปที่ออเดอร์",
  "back_to_splits": "กลับไปที่แยกออเดอร์",
  "sec_summary": "สรุปออเดอร์",
  "sec_items": "รายการสินค้า",
  "sec_money": "รายละเอียดการชำระเงิน",
  "sec_timeline": "ไทม์ไลน์การจัดส่ง",
  "status_section_marketplace": "สถานะการตลาด",
  "status_log_empty": "ยังไม่มีการเปลี่ยนแปลงสถานะ",
  "status_marketplace_csv_only_note": "รอ API ของมาร์เก็ตเพลส — ข้อมูลนี้มาจากการนำเข้า CSV",
  "lbl_sale_order": "รหัสคำสั่งขาย",
  "lbl_marketplace": "มาร์เก็ตเพลส",
  "lbl_seller": "ผู้ขาย",
  "lbl_customer": "ลูกค้า",
  "lbl_phone": "โทรศัพท์",
  "lbl_created": "สร้างเมื่อ",
  "lbl_payment": "การชำระเงิน",
  "lbl_status": "สถานะ",
  "lbl_tracking": "เลขพัสดุ / AWB",
  "lbl_pending": "รอดำเนินการ",
  "oi_title": "ข้อมูลออเดอร์",
  "ci_title": "ข้อมูลลูกค้า",
  "oi_number": "เลขที่ออเดอร์",
  "oi_package_no": "หมายเลขพัสดุ",
  "oi_marketplace_order_no": "หมายเลขออเดอร์มาร์เก็ตเพลส",
  "oi_marketplace_status": "สถานะการตลาด",
  "oi_created": "วันที่สร้างออเดอร์",
  "oi_updated": "อัปเดตล่าสุด",
  "oi_seller": "รหัสผู้ขาย",
  "oi_seller_name": "ชื่อผู้ขาย",
  "oi_seller_display": "ชื่อผู้ขาย",
  "seller_option": "{{name}} ({{id}})",
  "oi_channel": "ช่องทาง",
  "oi_courier": "บริษัทขนส่ง",
  "oi_tracking": "เลขพัสดุ / AWB",
  "oi_warehouse": "คลังสินค้า",
  "oi_paid_at": "ชำระแล้ว",
  "oi_shipped_at": "จัดส่งแล้ว",
  "oi_completed_at": "เสร็จสิ้น",
  "oi_created_by": "สร้างโดย",
  "ci_name": "ชื่อลูกค้า",
  "ci_phone": "เบอร์โทรลูกค้า",
  "ci_email": "อีเมลลูกค้า",
  "ci_social": "ชื่อโซเชียลลูกค้า",
  "ci_billing": "ชื่อผู้เรียกเก็บเงิน",
  "ci_ship_addr": "ที่อยู่จัดส่ง",
  "ci_bill_addr": "ที่อยู่เรียกเก็บเงิน",
  "pt_image": "รูปภาพ",
  "img_preview_hint": "คลิกเพื่อขยาย",
  "img_none": "ไม่มีรูปภาพ",
  "pt_sku": "SKU",
  "pt_type": "ประเภท",
  "pt_expand": "แสดงสินค้าฐาน",
  "pt_collapse": "ซ่อนสินค้าฐาน",
  "pt_freebies": "ของแถม",
  "pt_product": "ชื่อสินค้า",
  "pt_qty": "จำนวน",
  "pt_selling": "ราคาขาย",
  "pt_discount": "ส่วนลด",
  "pt_total": "รวม",
  "pay_title": "รายละเอียดการชำระเงิน",
  "pay_method": "วิธีชำระเงิน",
  "pay_channel": "ช่องทางชำระเงิน",
  "pay_status": "สถานะชำระเงิน",
  "pay_reference": "เลขอ้างอิงการชำระ",
  "pay_currency": "สกุลเงิน",
  "tot_title": "ยอดรวมออเดอร์",
  "tot_sub": "ยอดรวมย่อย",
  "tot_discount": "ส่วนลดรวม",
  "tot_item_disc": "ส่วนลดสินค้า",
  "tot_voucher": "โค้ดส่วนลด",
  "tot_shipping": "ค่าจัดส่ง",
  "tot_grand": "ยอดรวมสุทธิ",
  "tot_reconcile_ok": "ยอดรวมตรงกับรายการสินค้า",
  "tot_mismatch": "ยอดรวมไม่ตรงกัน — ออเดอร์อยู่ในการตรวจสอบ",
  "stl_title": "การชำระยอด",
  "stl_none": "ยังไม่มีข้อมูลการชำระยอดจาก {{mkp}}",
  "stl_buyer_paid": "ผู้ซื้อชำระ",
  "stl_fees": "ค่าธรรมเนียมแพลตฟอร์ม",
  "stl_net_payout": "ยอดรับสุทธิ",
  "stl_settled_at": "ชำระยอดแล้ว {{date}}",
  "stl_gross_mismatch": "ยอดรวมจากแพลตฟอร์มไม่ตรงกับยอดออเดอร์",
  "th_sku": "Sino SKU",
  "th_product": "สินค้า",
  "th_qty": "จำนวน",
  "th_unit": "ราคาต่อหน่วย",
  "th_line": "รวมรายการ",
  "tag_gift": "ของแถม",
  "tag_bundle": "บันเดิล",
  "tag_combo": "คอมโบ",
  "tag_unmapped": "SKU ไม่ตรงกัน",
  "m_original": "ยอดก่อนส่วนลด",
  "m_discount": "ส่วนลด",
  "m_shipping": "ค่าจัดส่ง",
  "m_order_fee": "ค่าธรรมเนียม",
  "m_total": "ยอดรวมสุทธิ",
  "inv_ok": "ตรวจสอบ ✓",
  "btn_view_payload": "ดู Payload ดิบ",
  "split_of": "แยกที่ {{n}} จาก {{m}}",
  "view_siblings": "ดูการแยกทั้งหมด",
  "related_orders_banner_text": "ออเดอร์นี้เป็น 1 ใน {{n}} พัสดุ จากออเดอร์การตลาดเดียวกัน ({{saleOrderId}})",
  "related_orders_view_package": "ดูพัสดุที่ {{index}}",
  "tl_received": "รับออเดอร์",
  "tl_reserved": "จองสต็อกแล้ว",
  "tl_picked": "Sino ยืนยันการหยิบ (CONFIRM_PICK)",
  "tl_packed": "แพ็คที่คลังสินค้า",
  "tl_packed_handover": "ส่งมอบให้ขนส่งแล้ว · {{time}}",
  "tl_shipped": "จัดส่งแล้ว (รายงานโดยมาร์เก็ตเพลส)",
  "tl_shipped_awb": "จัดส่งแล้ว (รายงานโดยมาร์เก็ตเพลส) · {{awb}}",
  "tl_delivered": "ส่งถึงลูกค้าแล้ว (รายงานโดยมาร์เก็ตเพลส)",
  "tl_superseded": "ออเดอร์ถูกแทนที่ — แทนที่ด้วยเวอร์ชันใหม่",
  "tl_cancelled": "ยกเลิกออเดอร์ — ปลดล็อก/การจอง",
  "pd_title": "Payload ออเดอร์",
  "pd_sub": "เหตุการณ์ขาเข้าดิบ (mock adapter)",
  "th_sale_order": "คำสั่งขาย",
  "th_split_count": "จำนวนแยก",
  "th_labels": "เลเบล",
  "split_rules": "กฎการแยกที่ใช้",
  "th_label": "เลเบล",
  "rule_carton": "จำกัดลัง (สูงสุด 3)",
  "rule_label": "จำกัดเลเบล (สูงสุด 5)",
  "rule_brand": "จัดกลุ่มแบรนด์ + MOQ",
  "rule_bundle": "แยกบันเดิล",
  "sec_split_overview": "ภาพรวมการแยก",
  "split_intro": "ออเดอร์นี้ถูกแยกโดยโมดูลแยกออเดอร์ (PRD §4.15) ก่อนส่งไป Sino แต่ละเลเบลจัดส่งแยกกัน",
  "so_detail_title": "รายละเอียดการแยกออเดอร์",
  "so_original": "ออเดอร์ต้นฉบับ",
  "so_customer": "ลูกค้า",
  "so_total_across": "{{total}} แบ่งเป็น {{n}} เลเบล",
  "so_label": "เลเบล",
  "so_split_n": "ชุดที่ {{n}} จาก {{m}}",
  "so_purpose": "ทำไมต้องแยก: คลัง Sino (LSC) จำกัด 1 เลเบลไม่เกิน 3 ลัง และ 1 ออเดอร์ไม่เกิน 5 เลเบล สินค้าบันเดิลต้องแยกเลเบลของตัวเอง โมดูลจะคำนวณการจัดเลเบลนี้ก่อนส่งออเดอร์ไป Sino",
  "trace_title": "ร่องรอยกฎการแยก (ตรวจสอบ)",
  "trace_own": "→ เลเบลของตัวเอง",
  "trace_group": "→ รวมเข้าเลเบล {{n}}",
  "trace_overflow": "→ ล้นเข้าเลเบล 5",
  "rule_1": "กฎ 1 · จำกัดลัง",
  "rule_2": "กฎ 2 · จำกัดเลเบล",
  "rule_3": "กฎ 3 · แบรนด์ + MOQ",
  "rule_4": "กฎ 4 · แยกบันเดิล",
  "rule_5": "กฎ 5 · ลังเดี่ยว",
  "rule_6": "กฎ 6 · แพ็ค→ลัง",
  "rule_7": "กฎ 7 · ล้นเลเบล 5",
  "th_return_id": "รหัสคืนสินค้า",
  "th_reason": "เหตุผล",
  "th_refund": "คืนเงิน",
  "th_return_status": "สถานะ",
  "th_updated": "อัปเดตเมื่อ",
  "ret_shop_id": "รหัสร้านค้า",
  "return_detail": "รายละเอียดการคืนสินค้า",
  "sec_return_items": "รายการที่คืน",
  "return_stock_note": "ระเบียนนี้ไม่เปลี่ยนแปลงสต็อก สต็อกคงเหลือจะอัปเดตเฉพาะเมื่อ Sino WMS ยืนยันว่าสินค้ากลับมาแล้ว (RETURNED)",
  "rd_order": "รหัสออเดอร์",
  "rd_return": "รหัสคืนสินค้า",
  "rd_amount": "จำนวนเงินคืน",
  "rd_reason": "เหตุผล",
  "rd_seller": "ผู้ขาย",
  "rd_tracking": "เลขพัสดุ",
  "th_seller": "ผู้ขาย",
  "oi_channel_status": "สถานะช่องทาง",
  "exc_filter": "เฉพาะข้อยกเว้น",
  "sel_count": "เลือก {{n}} รายการ",
  "bulk_export": "ส่งออกที่เลือก",
  "bulk_clear": "ล้าง",
  "t_bulk_export": "กำลังส่งออก {{n}} ออเดอร์ที่เลือก",
  "title_orders_export": "ส่งออกออเดอร์",
  "oe_config": "ตั้งค่าการส่งออก",
  "oe_range": "ช่วงวันที่",
  "oe_date_from": "ตั้งแต่วันที่",
  "oe_date_to": "ถึงวันที่",
  "oe_columns": "คอลัมน์",
  "oe_generate": "สร้างไฟล์ส่งออก",
  "oe_done": "ส่งออก {{count}} ออเดอร์แล้ว",
  "oe_empty": "ไม่มีออเดอร์ที่ตรงกับตัวกรองที่เลือก",
  "oe_failed": "ส่งออกไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",
  "attempts": "{{n}} ครั้ง",
  "btn_retry_now": "ส่งซ้ำตอนนี้",
  "t_copied": "คัดลอก payload แล้ว",
  "units": "หน่วย",
  "per_label": "รายการบนเลเบลนี้",
  "cb_select_all": "เลือกทั้งหมด",
  "cb_select_order": "เลือกออเดอร์ {{id}}",
  "loading_orders": "กำลังโหลดออเดอร์…",
  "empty_no_orders": "ไม่พบออเดอร์",
  "empty_no_orders_desc": "ลองปรับตัวกรองดู",
  "empty_no_match": "ไม่มีคำสั่งซื้อที่ตรงกับตัวกรอง",
  "empty_no_match_desc": "ลองเอาตัวกรองออกบางตัว หรือล้างทั้งหมด",
  "empty_no_returns": "ไม่พบรายการคืนสินค้า",
  "empty_no_returns_desc": "ลองปรับตัวกรองดู",
  "empty_order_not_found": "ไม่พบออเดอร์",
  "empty_order_not_found_desc": "ออเดอร์นี้อาจถูกลบ หรือลิงก์ไม่ถูกต้อง",
  "t_bulk_fail": "การดำเนินการเป็นชุดไม่สำเร็จ — กรุณาลองใหม่",
  "sync_last": "อัปเดตล่าสุด {{rel}}",
  "sync_in_progress": "กำลังซิงค์…",
  "sync_never": "ยังไม่เคยซิงค์",
  "refresh_syncing": "กำลังซิงค์…",
  "refresh_synced": "ซิงค์เมื่อ {{rel}}",
  "refresh_never": "ยังไม่เคยซิงค์",
  "refresh_not_found": "ไม่พบในมาร์เก็ตเพลส",
  "refresh_failed": "ซิงค์ไม่สำเร็จ",
  "refresh_not_configured": "ยังไม่ได้เชื่อมต่อมาร์เก็ตเพลส",
  "refresh_not_available": "ยังไม่เปิดให้รีเฟรชจากมาร์เก็ตเพลส",
  "btn_reconnect": "เชื่อมต่อใหม่",
  "sync_menu": "ซิงค์",
  "sync_menu_label": "ซิงค์ออเดอร์จากมาร์เก็ตเพลส",
  "sync_window_1h": "1 ชั่วโมงล่าสุด",
  "sync_window_6h": "6 ชั่วโมงล่าสุด",
  "sync_window_1d": "1 วันล่าสุด",
  "sync_window_7d": "7 วันล่าสุด",
  "sync_window_30d": "30 วันล่าสุด",
  "sync_window_90d": "90 วันล่าสุด",
  "sync_confirm_title": "ซิงค์{{window}}?",
  "sync_confirm_body": "อาจใช้เวลาหลายนาที และทำงานอยู่เบื้องหลัง",
  "sync_confirm_ok": "เริ่มซิงค์",
  "sync_confirm_cancel": "ยกเลิก",
  "sync_syncing": "กำลังซิงค์…",
  "sync_cancel": "ยกเลิก",
  "sync_chip_queued": "{{mkp}} …",
  "sync_chip_running": "{{mkp}} {{ingested}}/{{fetched}}",
  "sync_chip_done": "{{mkp}} ✓",
  "sync_chip_failed": "{{mkp}} ✗ {{error}}",
  "sync_chip_cancelled": "{{mkp}} ✗ ยกเลิกแล้ว",
  "t_sync_done_other": "ซิงค์แล้ว {{count}} ออเดอร์",
  "t_sync_partial_other": "ซิงค์เสร็จแต่มีข้อผิดพลาด — ซิงค์ได้ {{count}} ออเดอร์",
  "t_sync_mkp_failed": "{{mkp}}: {{error}}",
  "t_sync_cancelled_other": "ยกเลิกการซิงค์ — ซิงค์ได้ {{count}} ออเดอร์",
  "t_sync_unavailable": "ตอนนี้ซิงค์ไม่ได้ — ลองใหม่ในอีกสักครู่",
  "t_sync_start_fail": "เริ่มซิงค์ไม่สำเร็จ — ลองอีกครั้ง",
  "t_sync_cancel_fail": "ยกเลิกไม่สำเร็จ — การซิงค์อาจเสร็จไปแล้ว",
  "btn_resolve": "แก้ไข",
  "btn_open_seller_center": "เปิด Seller Center",
  "btn_open_inventory": "เปิดคลังสินค้า",
  "attention": {
    "tab": "ต้องตรวจสอบ",
    "any": "ทั้งหมด",
    "all": "ทั้งหมด",
    "tablist_label": "มุมมองออเดอร์"
  },
  "reason": {
    "oversold": "ขายเกินสต๊อก",
    "buyer_cancel_requested": "ผู้ซื้อขอยกเลิก"
  },
  "banner": {
    "oversold": {
      "title": "ขายเกินสต๊อก",
      "body": "SKU {{sku}} ({{mkp}}) — ขายได้ตอนนี้ {{sellable}} · สต็อกจริง {{on_hand}} · จองแล้ว {{reserve}}"
    },
    "buyer_cancel": {
      "title": "ผู้ซื้อขอยกเลิกออเดอร์",
      "body": "{{mkp}} รอคำตอบจากคุณถึง {{by}} กรุณาตอบคำขอใน Seller Center"
    }
  },
  "resolve": {
    "title": "แก้ไข: {{reason}}",
    "question": "คุณดำเนินการอย่างไร?",
    "other_note": "อื่น ๆ",
    "confirm": "ยืนยัน",
    "fail": "แก้ไขไม่สำเร็จ — กรุณาลองใหม่"
  },
  "activity": {
    "title": "กิจกรรม",
    "view_all": "ดูทั้งหมดใน Audit log",
    "add_note": "เพิ่มบันทึก…",
    "post": "โพสต์บันทึก",
    "older": "แสดงเหตุการณ์เก่ากว่า {{n}} รายการ",
    "src": {
      "marketplace": "มาร์เก็ตเพลส",
      "warehouse": "คลังสินค้า",
      "atlas": "Atlas",
      "people": "บุคคล"
    },
    "category": {
      "marketplace": "มาร์เก็ตเพลส",
      "warehouse": "คลังสินค้า",
      "stock": "สต๊อก",
      "note": "โน้ต",
      "settlement": "การชำระเงิน",
      "atlas": "Atlas"
    },
    "today": "วันนี้",
    "yesterday": "เมื่อวาน",
    "open_audit": "เปิดใน Audit log",
    "view_raw_payload": "ดูข้อมูล payload จากมาร์เก็ตเพลส",
    "all": "ทั้งหมด",
    "empty": "ยังไม่มีกิจกรรม",
    "delete_note": "ลบบันทึก",
    "show_system_events": "แสดงเหตุการณ์ของระบบ {{n}} รายการ",
    "hide_system_events": "ซ่อนเหตุการณ์ของระบบ",
    "error": "โหลดกิจกรรมไม่สำเร็จ ลองใหม่อีกครั้ง",
    "only_system": "มีเพียงเหตุการณ์ระบบ {{n}} รายการ — กด \"แสดงเหตุการณ์ระบบ\" เพื่อดู",
    "repeated": "พยายาม {{count}} ครั้ง",
    "repeated_title": "คลังสินค้าพยายามส่งสถานะ {{count}} ครั้งตั้งแต่ {{since}} และ Atlas ปฏิเสธทุกครั้ง"
  },
  "warn_oversold": "ขายเกินสต๊อก — ตรวจสอบก่อนจัดส่ง",
  "tip_label_printed": "ออกแล้ว",
  "tip_label_missing": "ยังไม่ออก",
  "tip_own_fleet": "ขนส่งเอง",
  "tip_label_missing_icon": "ยังไม่ออกเลขพัสดุ",
  "tip_fulfilment_label": "การจัดส่ง",
  "tip_label_label": "เลขพัสดุ",
  "tip_ship_by_label": "ต้องส่งภายใน",
  "tip_courier_label": "ขนส่ง",
  "tip_fleet_label": "กองรถ",
  "return_status_label": {
    "RETURN_OR_REFUND_REQUEST_COMPLETE": "คืนสินค้า/คืนเงินเสร็จสิ้น",
    "RETURN_OR_REFUND_REQUEST_CANCEL": "ยกเลิกคำขอคืนสินค้า/คืนเงิน",
    "RETURN_OR_REFUND_REQUEST_PENDING": "รอดำเนินการคืนสินค้า/คืนเงิน",
    "REQUEST_INITIATE": "ขอคืนสินค้า",
    "REQUESTED": "ส่งคำขอแล้ว",
    "ACCEPTED": "ยอมรับแล้ว",
    "REFUND_SUCCESS": "คืนเงินสำเร็จ",
    "RETURNED": "คืนสินค้าแล้ว",
    "CANCELLED": "ยกเลิกแล้ว",
    "REJECTED": "ปฏิเสธแล้ว",
    "CLOSED": "ปิดแล้ว",
    "JUDGING": "อยู่ระหว่างพิจารณา",
    "AWAITING_BUYER_SHIP": "รอผู้ซื้อจัดส่ง",
    "BUYER_SHIPPED_ITEM": "ผู้ซื้อจัดส่งสินค้าแล้ว",
    "TO_RETURN": "รอคืนสินค้า",
    "COMPLETED": "เสร็จสิ้น",
    "PROCESSING": "กำลังดำเนินการ"
  }
}
